var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7998 11.2838C2.65992 7.47797 4.49768 3.96229 7.13168 1.08376C7.17851 1.03281 7.23541 0.992135 7.29878 0.964311C7.36215 0.936486 7.4306 0.922119 7.4998 0.922119C7.56901 0.922119 7.63746 0.936486 7.70083 0.964311C7.7642 0.992135 7.8211 1.03281 7.86793 1.08376C7.97168 1.19626 8.05793 1.29126 8.12605 1.36814C10.6239 4.19431 12.3689 7.60461 13.1998 11.2838C11.8617 11.5656 10.4873 11.7506 9.0848 11.83L7.77918 14.4413C7.7532 14.4931 7.71331 14.5367 7.66397 14.5671C7.61463 14.5976 7.55779 14.6137 7.4998 14.6137C7.44182 14.6137 7.38498 14.5976 7.33564 14.5671C7.2863 14.5367 7.24641 14.4931 7.22043 14.4413L5.9148 11.83C4.53134 11.7518 3.15576 11.5692 1.7998 11.2838ZM7.4998 9.37501C7.99709 9.37501 8.474 9.17747 8.82563 8.82584C9.17726 8.47421 9.3748 7.99729 9.3748 7.50001C9.3748 7.00273 9.17726 6.52582 8.82563 6.17419C8.474 5.82256 7.99709 5.62501 7.4998 5.62501C7.00252 5.62501 6.52561 5.82256 6.17398 6.17419C5.82235 6.52582 5.6248 7.00273 5.6248 7.50001C5.6248 7.99729 5.82235 8.47421 6.17398 8.82584C6.52561 9.17747 7.00252 9.37501 7.4998 9.37501Z",
    fill: "#F45600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.759f6314e4c62aa6c05131a2a3d7b271.svg";
export { ForwardRef as ReactComponent };